import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgCalendar = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m8 13.35-1.34 1.34V12L8 10.68h1.33V20H8Zm9.36 2C17.36 18 16.08 20 14 20s-3.33-2.22-3.35-4.67S12 10.68 14 10.68s3.36 2.32 3.36 4.69Zm-5 0c0 2 .76 3.1 1.67 3.1s1.67-1.17 1.67-3.1-.7-3.11-1.7-3.11-1.68 1.1-1.66 3.13ZM21.34 4h-4V1.34a1.34 1.34 0 0 0-2.67 0V4H9.33V1.34a1.34 1.34 0 0 0-2.67 0V4h-4a1.28 1.28 0 0 0-1.33 1.24V22.6A1.42 1.42 0 0 0 2.75 24h18.5a1.42 1.42 0 0 0 1.42-1.41V5.35A1.29 1.29 0 0 0 21.44 4ZM20 21.36H4v-12h16Z"
    }));
export default SvgCalendar;
